import { CalendarService } from '../services/CalendarService';

export function useCalendarService(): CalendarService {
  return new CalendarService(useApiClient(), useUserStore());
}
